import React, { Component } from "react";
import { NavLink, Link } from "react-router-dom";
import {
  getSession,
  handleSubmit,
  toggleDarkMode,
  toggleDarkModeX,
} from "./function";
import { hideRegion } from "../Constant";
import userIcon from "../Assets/userIcon.png";
import betaIcon from "../Assets/beta.png";
import $ from "jquery";

class SideBar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      userID: "",
      password: "",
      message: "",
    };
  }

  componentDidMount() {
    toggleDarkMode();

    $(function () {
      if (localStorage.getItem("theme") == "dark") {
        $(".dark-mode").addClass("active");
        $(".light-mode").removeClass("active");
      } else {
        $(".light-mode").addClass("active");
        $(".dark-mode").removeClass("active");
      }

      $(".dark-mode").on("click", function () {
        $(this).addClass("active");
        $(".light-mode").removeClass("active");
        localStorage.setItem("theme", "dark");
      });

      $(".light-mode").on("click", function () {
        $(this).addClass("active");
        $(".dark-mode").removeClass("active");
        localStorage.setItem("theme", "light");
      });
    });
  }

  componentDidUpdate() {}

  render() {
    return (
      <>
        <aside>
          <div className={this.props.class ? this.props.class : ""}>
            <div className="hide-mobiles">
              <div className="dash-aside hide-mobile">
                <div className="contain">
                  <div className="side-details-wrap">
                    <div className="flex first hidden">
                      <img
                        height="40px"
                        src={userIcon}
                        alt={getSession("name")}
                      />
                    </div>
                    <div className="flex flex2">
                      <div className="ellipse">
                        <b>{getSession("name")}</b>
                      </div>
                      <br />
                      <div className="ellipse">{getSession("userID")}</div>
                    </div>
                  </div>

                  <div className="nav-title hidden">Menu</div>
                  <div className="nav-list">
                    <NavLink to="/dashboard" className="nav-side-link">
                      <i className="fa fa-tachometer hidden"> </i> Dashboard
                    </NavLink>

                    <NavLink to="/my-commit" className="nav-side-link">
                      <i className="fa fa-play hidden"> </i> My Commits
                    </NavLink>

                    {getSession("contractor") == "0" ? (
                      <>
                        <NavLink to="/submit" className="nav-side-link hidden">
                          Submit File
                        </NavLink>

                        <NavLink
                          to="/resubmit"
                          className="nav-side-link hidden"
                        >
                          Resubmit File
                        </NavLink>
                      </>
                    ) : (
                      <>
                        <NavLink
                          to="/publisher"
                          className="nav-side-link hidden"
                        >
                          Publisher
                        </NavLink>
                      </>
                    )}

                    <NavLink to="/change/password" className="nav-side-link">
                      <i className="fa fa-lock hidden"> </i> Change Password
                    </NavLink>

                    {/*} <NavLink to="/my-review" className="nav-side-link">
                My Review
            </NavLink>

            <NavLink to="/feedback" className="nav-side-link">
                Feedbacks
        </NavLink>*/}

                    {/*<NavLink to="/wallet" className="nav-side-link">
                Wallets
    </NavLink>*/}

                    <NavLink to="/contact" className="nav-side-link">
                      <i className="fa fa-address-book hidden"> </i> Contact Us
                    </NavLink>

                    <a
                      href="#logout"
                      className="nav-side-link"
                      onClick={() => handleSubmit(this.props.self, "logout")}
                    >
                      <i className="fa fa-power-off hidden"> </i> Logout
                    </a>

                    {(getSession("reviewer") && getSession("reviewer") > 0) ||
                    (getSession("editor") && getSession("editor") > 0) ? (
                      <></>
                    ) : (
                      <></>
                    )}
                  </div>
                  <br />
                  <div className="nav-title2 hidden">
                    <button
                      className="btn b dark-mode"
                      style={{
                        background: "#373737",
                        color: "#fff",
                        padding: "10px 20px",
                        textAligns: "center",
                        cursor: "pointer",
                      }}
                      onClick={(e) => toggleDarkModeX()}
                    >
                      <i
                        className="fa fa-moon"
                        style={{
                          fontSize: "20px",
                          color: "#fff",
                          background: "#414750",
                          padding: "15px",
                          borderRadius: "50%",
                          marginRight: "10px",
                        }}
                      ></i>{" "}
                      Dark Mode
                    </button>
                    <button
                      className="btn b light-mode hidden"
                      style={{
                        background: "#E9ECEE",
                        padding: "10px 20px",
                        textAligns: "center",
                        cursor: "pointer",
                      }}
                      onClick={(e) => toggleDarkModeX()}
                    >
                      {" "}
                      Light Mode{" "}
                      <i
                        className="fa-solid fa-sun"
                        style={{
                          fontSize: "20px",
                          color: "#0766C6",
                          background: "#b0b2b5",
                          padding: "15px",
                          borderRadius: "50%",
                          marginLeft: "10px",
                        }}
                      ></i>
                    </button>
                  </div>

                  <div className="tog-switch-theme hiddens">
                    <div
                      className="toggle-container light"
                      id="toggle-container"
                    >
                      <i className="fa-solid fa-sun"></i>
                      <label className="switch">
                        <input
                          type="checkbox"
                          className="switch-theme"
                          id="switch-theme"
                          onClick={(e) => toggleDarkModeX()}
                        />
                        <span className="slider-switch round"></span>
                      </label>
                      <i className="fa-solid fa-moon"></i>
                    </div>

                    <div className="darkCircle"></div>
                    <div className="lightCircle grow"></div>
                  </div>
                  <div className="sd-switch-theme hidden">
                    <div
                      className="mode-switch light-mode"
                      onClick={(e) => toggleDarkModeX()}
                    >
                      {" "}
                      <i
                        className="fa-solid fa-sun"
                        style={{
                          fontSize: "13px",
                          color: "#0766C6",
                          background: "#b0b2b5",
                          padding: "7px",
                          borderRadius: "50%",
                          marginLefts: "10px",
                        }}
                      ></i>{" "}
                      Light
                    </div>
                    <div
                      className="mode-switch dark-mode active"
                      onClick={(e) => toggleDarkModeX()}
                    >
                      <i
                        className="fa fa-moon"
                        style={{
                          fontSize: "13px",
                          color: "#fff",
                          background: "#414750",
                          padding: "7px",
                          borderRadius: "50%",
                          marginRights: "10px",
                        }}
                      ></i>{" "}
                      Dark
                    </div>
                  </div>

                  <div
                    className="nav-title2 hidden"
                    style={{ background: "transparent", textAlign: "center" }}
                  >
                    <br />
                    <img
                      src={betaIcon}
                      alt="Beta"
                      style={{ maxWidth: "50%" }}
                    />
                  </div>

                  <div
                    className="nav-title2"
                    style={{
                      background: "teal",
                      color: "#fff",
                      textAlign: "center",
                    }}
                    hidden={hideRegion}
                  >
                    ⌖ {getSession("region")} 📌
                  </div>
                </div>
              </div>
            </div>
          </div>
        </aside>
      </>
    );
  }
}

export default SideBar;
